import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // state: 存放变量
  state: {
    token: localStorage.getItem('token') || '',
    fmyqVisited: JSON.parse(localStorage.getItem('fmyqVisited'))|| [],
    jhyjVisited: JSON.parse(localStorage.getItem('jhyjVisited')) || []
  },
  // mutation: 存放方法
  mutations: {
    getToken (state, value) {
      state.token = value
      localStorage.setItem("token", value)
    },
    getfmyqVisited (state,value) {
      state.fmyqVisited.push(value)
      localStorage.setItem('fmyqVisited', JSON.stringify(state.fmyqVisited))
    },
    getjhyjVisited(state,value) {
      state.jhyjVisited.push(value)
      localStorage.setItem('jhyjVisited', JSON.stringify(state.jhyjVisited))
    }
  }
})